export default {
  api: {
    baseUrl: 'https://venteny.api.x.makna.ai',
    chatUrl: 'https://venteny.api.chat.makna.ai',
  },
};
